import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { getIntendType, isWHW, isWWM, isWHWP2 } from '../../components/common/Helpers/index';

export const getZipDetailsFromApi = (data) => ({
  type: Constants.GET_ZIP_DETAILS_FROM_API,
  data,
});

export const getZipDetails = (value) => {
  const postData = { data: { zipCode: value } };
  return new Promise((resolve) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().zipMarketDetailsUrl}`;
    HttpService.post(apiURL, postData)
      .then((response) => {
        resolve(response);
      })
      .catch(() => {});
  });
};

export const creditCheckFailReload = (data) => ({
  type: 'INITIATE_CREDIT_FAILED_RLOAD',
  data,
});

export const runD2DCreditReview = (data) => ({
  type: Constants.RUN_D2D_CREDIT_REVIEW,
  data,
});

export const getCreditCheckOnClick = (data) => ({
  type: Constants.GET_CREDIT_CHECK_INFO_ON_CLICK,
  data,
});

export const updateCreditCheckSuccess = (data) => ({
  type: 'UPDATE_CREDIT_REVIEW',
  data,
});
// export const postEidQuestionsAnswers = (eidData) =>
//   // alert('eidpost action');
//   ({ type: 'POST_EID_QUESTIONS_ANSWERS', eidData });

export const postEidQuestionsAnswers = (eidData) => ({ type: 'POST_EID_QUESTIONS_ANSWERS', eidData });
export const postEidQuestionsAnswersApi = (action) => {
  const data = {
    serviceHeader: {
      statusMsg: 'PEGA generated message',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          customerInfo: {
            processingMTN: '',
            originalCreditApprovalNumber: '',
            customerType: 'N',
          },
          cartInfo: {
            itemType: 'SUBMIT-EID-ANSWERS',
            intendType: 'NSE_5G',
            action: 'UPDATE',
            eidVerifier: action.eidData,
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: 'NSE_5G',
            processStep: 'EligibilityReview',
            processAction: 'submitEidAnswers',
          },
        },
      },
    },
  };
  return HttpService.post(`${getSecureBaseUrl()}${apiUrls().nse5GProcessEidFlow}`, data);
};

export const runD2DCreditReviewApi = (data) => {
  const intendTypeval = getIntendType();

  const postData = {
    serviceHeader: {
      clientId: 'VZW-ECOM',
      statusMsg: 'PEGAgeneratedmessage',
      correlationId: '69a66ef4d7e344dfb2db299209ea8333',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          customerInfo: {
            customerType: 'N',
          },

          cartInfo: {
            itemType: 'CREDITCHECK',
            intendType: intendTypeval,
            action: 'UPDATE',
            contactDetails: {
              firstName: data.custData.fName,
              lastName: data.custData.lName,
              contactNumber: data.custData.phoneNumber.trim(),
              address: {
                addressLine1: data.custData.address,
                addressLine2: data.custData.line2,
                zipCode: data.custData.zipCode,
                city: data.custData.city,
                state: data.custData.state,
                county: '',
              },
            },
            ssn: data.custData.ssn,
            dob: data.custData.dateOfBirth,
            iwvSkipCreditCheck: false,
            skipByodCreditCheck: false,
            accountPin: data.custData.accountPin ? data.custData.accountPin : '',
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: intendTypeval,
            processStep: 'ShoppingCart',
            processAction: 'initiateCreditCheck',
          },
        },
      },
    },
  };
  return HttpService.post(`${getSecureBaseUrl()}${apiUrls().runCreditReviewUrl}`, postData);
};

export const runCreditReview = (custData) => {
  const intendTypeval = getIntendType();

  const postData = {
    serviceHeader: {
      clientId: 'VZW-ECOM',
      statusMsg: 'PEGAgeneratedmessage',
      correlationId: '69a66ef4d7e344dfb2db299209ea8333',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          customerInfo: {
            customerType: 'N',
          },

          cartInfo: {
            itemType: 'CREDITCHECK',
            intendType: intendTypeval,
            action: 'UPDATE',
            contactDetails: {
              firstName: custData.fName.trim(),
              lastName: custData.lName.trim(),
              contactNumber: custData.phoneNumber,
              address: {
                addressLine1: custData.address,
                addressLine2: custData.line2,
                zipCode: custData.zipCode,
                city: custData.city,
                state: custData.state,
                county: '',
              },
            },
            ssn: custData.ssn,
            dob: custData.dob,
            iwvSkipCreditCheck: false,
            skipByodCreditCheck: false,
            accountPin: custData.accountPin ? custData.accountPin : '',
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: isWHW() || isWWM() || isWHWP2() ? 'RedemptionAccessory' : intendTypeval,
            processStep: isWHW() || isWWM() || isWHWP2() ? 'PromoHub' : 'ShoppingCart',
            processAction: 'initiateCreditCheck',
          },
        },
      },
    },
  };
  return HttpService.post(`${getSecureBaseUrl()}${apiUrls().runCreditReviewUrl}`, postData);
};

// d2d eid questions post service call
export const postD2DEidQuestionsApi = (data) => HttpService.post(`${getSecureBaseUrl()}${apiUrls().inspicioSendMessage}`, data);

export const getShippingDetailsFromApi = (data, homePhone) => ({
  type: 'GET_SHIPPING_DETAILS_FROM_API',
  data,
  homePhone,
});
